import React from 'react'

import { NavBar } from '../containers/navbar'

export const Header = () => <NavBar />

Header.propTypes = {}

Header.defaultProps = {}
